import * as React from "react";
import List from "@material-ui/core/List/List";
import { LinkModel } from "../model/autogen/LinkModel";
import ListItem from "@material-ui/core/ListItem/ListItem";

export interface LinkCollectionDisplayProps {
    links: LinkModel[];
}

export const LinkCollectionDisplay = (props: LinkCollectionDisplayProps) => {
    return <List>
        {(props.links || []).map(lnk => <ListItem key={lnk.id}><a href={lnk.url} target="_blank">{lnk.title}</a></ListItem>)}
    </List>;
}


// WEBPACK FOOTER //
// ./src/components/link-collection-display.tsx